/**
 * Formats and parses the component and identifier to a valid test id
 * @param component - The component name - e.g. "onboard-input", "select-input", "button"
 * @param identifier - The unique identifier for the component, e.g. component key, label, id
 * @returns The formatted test id - e.g. "onboard-input-first-name", "select-input-how-would-you-categorize-your-organization"
 */
export function formatTestId(component: string, identifier: string): string {
  return `${identifier
    .toLowerCase()
    .replace(/[.,'?]/g, '')
    .replace(/ /g, '-')}-${component}`;
}
